import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('TEST_WEBHOOK');
